import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
const Navbar = () => {
const item=useSelector((state)=> state.cart)

  return (
    
    <div className='main-div'>
        <header className="header">
        <span className='logo'>mj mart</span>
        <div className='nvacnt'>
            <Link className='navlink'  to={'/'} >Home</Link>
            <Link  className='navlink' to={'/cart'} >Cart</Link>
            <span className='cartCont'>
               <b> Cart Items</b> :{item.length}
            </span>
        </div></header>
    </div>
  )
}

export default Navbar